module.exports = __webpack_public_path__ + "static/20230619_171-3e88a6cb7221e6c4d8f857c9561f1841.jpg";